"use client";

import React from "react";

interface PageData {
  name: string;
  userCount: string;
}

interface CaseStudyParaListProps {
  title?: string | undefined;          // ✅ allow undefined
  pages: PageData[];
  className?: string;
  userCountLabel?: string | undefined; // ✅ allow undefined
  renderItem?: (page: PageData, index: number) => React.ReactNode;
  showQuotes?: boolean | undefined;    // ✅ allow undefined
}

const CaseStudyParaList: React.FC<CaseStudyParaListProps> = ({
  title = "Top Performing Pages:",
  pages,
  className = "",
  userCountLabel = "",
  renderItem,
  showQuotes = false,
}) => {
  return (
    <div
      className={`relative max-w-7xl mx-auto overflow-hidden rounded-2xl shadow-md md:shadow-none ${className}`}
    >

      <div className="relative text-center text-base rounded-2xl overflow-hidden lg:text-lg text-[#1b1b1b] leading-relaxed border border-[#ccc]/48 bg-white/70 lg:p-8 p-4">

        {/* Title */}
        {title && (
          <h3
            className="text-center text-lg sm:text-xl md:text-2xl
          font-semibold text-[#1b1b1b] mb-4 sm:mb-5 md:mb-6"
          >
            {title}
          </h3>
        )}

        {/* Pages List */}
        <ul className="space-y-1">
          {pages.map((page, index) =>
            renderItem ? (
              renderItem(page, index)
            ) : (
              <li
                key={index}
                className="flex flex-wrap text-center justify-center 
              text-base sm:text-lg"
              >
                <span className="text-[#272d57] font-bold mr-2">
                  {showQuotes ? `"${page.name}"` : page.name}
                </span>
                <span className="text-[#1b1b1b]">
                  {page.userCount} {userCountLabel}
                </span>
              </li>
            )
          )}
        </ul>
      </div>
    </div>
  );
};

export default CaseStudyParaList;
